var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DoughnutChartGenerator',{style:({ width: _vm.size, height: _vm.size }),attrs:{"chart-data":_vm.data,"chart-options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }